import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Table } from "reactstrap";
import Spinner from "web/components/Spinner";
import { AiOutlineCloudDownload } from "react-icons/ai";
import Layout from "web/components/Layout";
import { useHistory } from "react-router-dom";
import { getSpecFileDetails } from "redux/actions/auth";
import AlertModal from "web/components/AlertModal";
import styles from "./spect.module.scss";
import styled from "styled-components";
import { Helmet } from "react-helmet"; 
import {
  MobileViewContainer,
  Heading,
  AccordionContainer,
} from "web/pages/private/CommonPages/SpecificationV1/MobileViewStyled";
import Accordion from "@material-ui/core/Accordion";
import AccordionDetails from "@material-ui/core/AccordionDetails";
import AccordionSummary from "@material-ui/core/AccordionSummary";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import BuyArrowImage from "web/assets/images/right-arrow-dark-blue.webp";

const Specification = () => {
  const dispatch = useDispatch();
  let history = useHistory();
  const [response, setResponse] = useState();
  const token = localStorage.getItem("token");
  const loaderVisible = useSelector(
    (state) => state.appReducer.loaderVisible
  );
  // const [file, setFile] = useState("");
  // const [fileName, setFileName] = useState("");
  const [modal, setModal] = useState(false);
  const [modalContent, setModalContent] = useState("");
  const [modalLink, setModalLink] = useState("");
  const toggleModal = () => setModal(!modal);
  const [expanded, setExpanded] = React.useState(false);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    fetchMyAPI();
  }, []);

  const fetchMyAPI = async () => {
    if (token === null) {
      setModalContent("Please Sign In again.");
      setModalLink('/sign-in');
      toggleModal();
    } else {
      let response = await dispatch(getSpecFileDetails(token));
      if (response.success) {
        setResponse(response.data);
      } else {
        if (response.message === "Unauthorized (Invalid token)") {
          history.push('/sign-in');
          window.location.reload(false);
        } else {
          setModalContent(response?.data?.error?.message || response?.data?.message || response?.message || 'Something went wrong, please try again in some time.');
          setModalLink("");
          toggleModal();
        }
      }
    }
  };

  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  let headerArr = [
    { title: "Material" },
    { title: "Condition" },
    { title: "Moisture Content" },
    { title: "Pallet Type" },
    { title: "Pallet Size" },
    { title: "Grade" },
    { title: "Heat Treated" },
    { title: "Spec Sheet" },
  ];

  const handleDownload = (file) => {
    const fileUrl =
      process.env.REACT_APP_API_URL + "/user/image/" + file;
    window.open(fileUrl);
  };

  const dispalyFields = (response, items, index) => {
    return (
      <AccordionContainer>
        <Accordion
          expanded={expanded === "panel" + index}
          onChange={handleChange("panel" + index)}
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1bh-content"
            id="panel1bh-header"
          >
            <div className="accordion-header">
              <h3>{items.material}</h3>
              <h3>{items.palletType}</h3>
              <h3 className="last-field">{items.palletSize}</h3>
            </div>
          </AccordionSummary>
          <AccordionDetails>
            <div className="accordion-detail-section">
              <div className="text-section">
                <div>
                  <p className="label-text">Condition</p>
                  <p> {items.condition}</p>
                </div>
                <div>
                  <p className="label-text">Moisture Content</p>
                  <p> {items.moistureContent !== '' ? items?.moistureContent : 'NA'}</p>
                </div>
                <div>
                  <p className="label-text">Heat treated</p>
                  <p> {items.htTreated === "Y" ? "Yes" : "No"}</p>
                </div>
                <div>
                  <p className="label-text">Grade</p>
                  <p>
                    {" "}
                    {items.grade && items.grade.trim() !== ""
                      ? items.grade
                      : "NA"}
                  </p>
                </div>
              </div>

              {(items.specSheetFile &&
                items.specSheetFile !== null &&
                items.specSheetFile !== "N/A" &&
                items.specSheetFile !== "Custom Spec Upload") && (
                <div className="download-wrapper">
                      <div className="downloadable">
                    <span>Spec Sheet</span>
                        <AiOutlineCloudDownload
                          onClick={() => handleDownload(items.specSheetFile)}
                        />
                  </div>
                </div>
              )}
            </div>
          </AccordionDetails>
        </Accordion>
      </AccordionContainer>
    );
  };

  const SpecificationMobileView = () => {
    return (
      <MobileViewContainer>
        <Heading>
          <img src={BuyArrowImage} alt="arrow-img" />
          <h2>Specifications Details</h2>
        </Heading>
        {response &&
          response.map((items, index) => (
            <>{dispalyFields(response, items, index)}</>
          ))}
        {response && response?.length === 0 && (
          <p
            style={{ position: "absolute", width: "100%", textAlign: "center" }}
          >
            No records found
          </p>
        )}
      </MobileViewContainer>
    );
  };

  return (
    <>
    <Helmet title="Detailed Information and Specifications for Pallets | PalletTrader" >
      <meta name="description"
    content="Detailed specifications for pallets. Find the necessary information you need, including dimensions, weight limits, materials, and other important details." />
        <meta name="robots" content="index,follow" />
        <link rel="canonical" href="https://www.pallettrader.com/specifications" />
      </Helmet>
    <Layout pageType="Dashboard" topBarViewMobile={"hide"}>
      {loaderVisible && <Spinner />}
      <MainContainer>
        <SpecificationMobileView />

        <TableWrapper className="web-view">
          <div>
            <div class="community-details-header seller">
              <div class="community-name">
                <h4>Specifications Detail</h4>
              </div>
            </div>
            <TableSection>
              <Table responsive style={{ minHeight: "135px" }}>
                <thead>
                  <tr>
                    {headerArr.map((items, index) => (
                      <th key={index}>{items.title}</th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {response?.map((items, index) => (
                    <tr key={index} className={styles.palletSizeStyle}>
                      <td title={items.material}>{items.material}</td>
                      <td title={items.condition}>{items.condition}</td>
                      <td title={items.moistureContent}>
                        {items.moistureContent !== '' ? items?.moistureContent : 'NA'}
                      </td>
                      <td title={items.palletType}>{items.palletType}</td>
                      <td title={items.palletSize}>{items.palletSize}</td>
                      <td title={items.grade}>
                        {items.grade && items.grade.trim() !== ""
                          ? items.grade
                          : "NA"}
                      </td>
                      <td>{items.htTreated === "Y" ? "Yes" : "No"}</td>
                      <td title={items.specSheetFile}>
                        {items.specSheetFile &&
                        items.specSheetFile !== null &&
                        items.specSheetFile === "Custom Spec Upload" ? (
                          "NA"
                        ) : items.specSheetFile &&
                          items.specSheetFile !== null &&
                          items.specSheetFile !== "N/A" ? (
                          <AiOutlineCloudDownload
                            onClick={() =>
                              handleDownload(items.specSheetFile)
                            }
                          />
                        ) : (
                          "NA"
                        )}
                      </td>
                    </tr>
                  ))}
                  {response && response?.length === 0 && (
                    <p
                      style={{
                        position: "absolute",
                        width: "100%",
                        textAlign: "center",
                      }}
                    >
                      No records found
                    </p>
                  )}
                </tbody>
              </Table>
            </TableSection>
          </div>
        </TableWrapper>
      </MainContainer>

      <AlertModal
        isOpen={modal}
        toggle={toggleModal}
        title=""
        content={modalContent}
        link={modalLink}
        callBackAlert={(val) => {}}
      />
    </Layout>
    </>
  );
};

export default Specification;
// const MobileView = styled.div`
//   padding: 12px;
//   display: none;
//   .downloadable {
//     svg {
//       height: 17px;
//       width: 17px;
//       color: #61b01f;
//     }
//   }
//   .data-box {
//     border-radius: 4px;
//     box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.16);
//     background-color: #fff;
//     margin-bottom: 12px;
//     .data-box-header {
//       background-color: #105f8d;
//       display: flex;
//       justify-content: space-between;
//       padding: 0 17px;
//       height: 31px;
//       grid-template-columns: 1fr 1fr 1fr;
//       p {
//         font-size: 11px;
//         font-family: "latobold";
//         line-height: 1.18;
//         letter-spacing: -0.58px;
//         color: #fff;
//         :last-child {
//           justify-self: flex-end;
//         }
//         :nth-child(2) {
//           justify-self: center;
//         }
//       }
//     }
//     .data-box-body {
//       padding: 0 17px;
//       > div {
//         border-bottom: solid 1px #707070;
//         padding: 8px 0;
//         display: flex;
//         gap: 5px;
//         :last-child {
//           border: none;
//         }
//         p {
//           flex: 1;
//           font-size: 12px;
//           line-height: 1.25;
//           letter-spacing: -0.64px;
//           font-family: "latobold";
//           margin: 0;
//         }
//       }
//     }
//   }
//   .community-details-header {
//     min-height: auto;
//     padding-left: 48px;
//     margin-bottom: 15px;
//   }
//   .community-details-header::after {
//     background-size: 71%;
//     height: 28px;
//     width: 56px;
//     left: 0;
//     background-position: left center;
//     top: 3px;
//   }
//   .community-name {
//     h4 {
//       font-size: 25px;
//       line-height: 1.32;
//       margin: 0;
//     }
//   }
//   @media (max-width: 560px) {
//     display: block;
//   }
// `;

const TableWrapper = styled.div`
  padding: 20px;

  > div {
    border-radius: 10px;
    box-shadow: 0 2px 10px 0 rgb(0 0 0 / 16%);
    padding: 15px 28px;
    @media (max-width: 767px) {
      padding: 15px;
      overflow: hidden;
    }
  }
  @media (max-width: 1250px) {
    padding: 15px;
  }
`;

const TableSection = styled.div`
  padding: 0px 12px;
  overflow: auto;
  .table {
    overflow: auto;
    min-width: 1000px;
  }
  .table-responsive {
    max-height: calc(100vh - 243px);
  }
  .table thead th {
    vertical-align: top;
    position: sticky;
    top: 0;
    background: #fff;
    z-index: 1;
  }
  .table thead th,
  .table td,
  .table th {
    border: none;
    font-size: 16px;
    svg {
      width: 29px;
      height: 20px;
      cursor: pointer;
    }
  }
  .table tbody tr:nth-child(odd) {
    background-color: #fbfbfb;
  }
  tbody {
    position: relative;
  }
  @media (max-width: 767px) {
    max-width: 100%;
    overflow: auto;
  }
`;

const MainContainer = styled.div`
  max-width: 1472px;
  margin: 0 auto;
  padding: 0 10px;
  .web-view {
    display: none;
  }
  @media (min-width: 561px) {
    .web-view {
      display: block;
    }
  }
`;
